"use client"

import Link from "next/link"
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react"

import { Button } from "@/components/fun-ui/Button"
import { CommunicateWithUs } from "@/components/CommunicateWithUs"
import { cn } from "@/lib/utils"

const headerButtonClassName = cn(
  "rounded-full",
  "bg-[#F4F4F4] text-[#000000] h-14 text-xl px-8",
  "hover:text-primary-foreground hover:bg-primary md:h-8 md:text-xs md:px-5",
);

export function SiteHeaderActions() {
  const [cookieHasNickname, setCookieHasNickname] = useState<boolean | null>(null);
  const pathname = usePathname();
  const isLoginPage = pathname === '/login';

  useEffect(() => {
    setCookieHasNickname(document.cookie.indexOf('nickname') !== -1);
  }, []);

  return (
    <nav className="flex shrink-0 items-center">
      <CommunicateWithUs />
      {isLoginPage ? null : cookieHasNickname === null ? (
        <Button className={headerButtonClassName} variant="default" disabled>登录</Button>
      ) : (
        !cookieHasNickname ? (
          <Link
            href="/login"
            className="ml-2"
            prefetch={false}
          >
            <Button className={headerButtonClassName} variant="default">登录</Button>
          </Link>
        ) : (
          <Link
            href="/papers"
            className="ml-2"
            prefetch={false}
          >
            <Button className={headerButtonClassName} variant="default">进入 Findin</Button>
          </Link>
        )
      )}
    </nav>
  )
}
